import { createFileRoute } from "@tanstack/react-router";
import { AdminAiPage } from "@/features/admin/ai";

export const Route = createFileRoute("/admin/ai")({
  head: () => ({ meta: [{ title: "AI models · Admin · Malfak" }] }),
  component: AdminAiPage,
});
